import { PdfH1, PdfTable } from 'pages/v2/compiler/PDF/Styles.styled';
import { ScenarioItemModel } from 'types/types';

type TProps = {
  scenario: ScenarioItemModel;
};

const DefaultScenarioInformationPdf = ({ scenario }: TProps) => {
  return (
    <div>
      <PdfH1>Scenarios</PdfH1>
      <PdfTable>
        <thead>
          <tr>
            <th style={{ width: '30%' }}></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Name of the default scenario</td>
            <td>{scenario.name}</td>
          </tr>
          <tr>
            <td>Description of the default scenario</td>
            <td>{scenario.description}</td>
          </tr>
        </tbody>
      </PdfTable>
    </div>
  );
};

export default DefaultScenarioInformationPdf;
